import { importProvidersFrom } from '@angular/core';
import { AppStoreModule } from './app-store.module';

export const providers = [importProvidersFrom(AppStoreModule)];
